<template>
  <div class="c-aed-map">
    <GmapMap
      :center="{ lat: placement.latitude, lng: placement.longitude }"
      :zoom="20"
      map-type-id="satellite"
      :options="{
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        disableDefaultUi: false
      }"
      :tilt="0"
      style="width: 100%; height: 100%"
    >
      <GmapMarker
        :position="{
          lat: placement.latitude,
          lng: placement.longitude
        }"
        :clickable="false"
        :draggable="true"
        :icon="icon"
        @dragend="confirmPositionChange($event)"
      />
    </GmapMap>
    <transition name="o-transition__modal">
      <CallCenterAEDModal
        v-if="showModal"
        @close="closeModal"
        :corner-close="false"
      >
        <h2
          class="o-heading o-heading--size-2 o-heading--section o-heading--border"
          slot="header"
        >
          {{ translationsAddress.placementChangedManually }}
          {{ translationsAddress.doYouWishToUpdatePlacement }}
        </h2>
        <div slot="footer">
          <div class="o-grid o-grid--gutter-small">
            <div class="o-grid__group">
              <div
                class="c-modal-comment__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button class="o-button" @click="newPossition">
                  {{ translationsCustom.save }}
                </button>
              </div>
              <div
                class="c-modal-comment__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button
                  class="o-button o-button--transparent"
                  @click="closeModal"
                >
                  {{ translationsCustom.cancel || "" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </CallCenterAEDModal>
    </transition>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import { mapGetters, mapState } from "vuex";
import marker from "@/media/scope.png";
export default {
  name: "c-aed-map",
  data() {
    return {
      section: "placement",
      name: "Map",
      map: {},
      showModal: false,
      newLatitude: null,
      newLongitude: null
    };
  },
  computed: {
    ...mapGetters("aed", ["placement"]),
    ...mapState("translations", {
      translationsAddress: "address",
      translationsCustom: "custom"
    }),
    google: gmapApi,
    icon() {
      const icon = {
        url: marker,
        size: {
          width: 90,
          height: 90
        },
        anchor: {
          x: 45,
          y: 45
        }
      };
      return icon;
    }
  },
  methods: {
    confirmPositionChange(event) {
      this.showModal = true;
      this.newLatitude = event.latLng.lat();
      this.newLongitude = event.latLng.lng();
    },
    newPossition() {
      const payload = {
        method: "PATCH",
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: this.section,
        data: {
          latitude: this.newLatitude,
          longitude: this.newLongitude
        }
      };
      const { dispatch } = this.$store;
      dispatch("aed/setSection", payload);
      this.$emit("markerDraged", event);

      this.closeModal();
    },
    closeModal() {
      this.showModal = false;
      this.newLatitude = null;
      this.newLongitude = null;
    }
  }
};
</script>

<style lang="scss">
.c-aed-map {
  background-color: $s-cp-neutral-800;
  width: 100%;
  height: 100%;
}
</style>
